import { Group } from "@mantine/core";

// Sticky modal action bar — keeps the buttons pinned to the bottom of the modal so they
// stay visible while the form scrolls.
export function FormModalFooter({ children }) {
  return (
    <Group
      justify="flex-end"
      gap="sm"
      style={{
        position: "sticky",
        bottom: 0,
        background: "var(--mantine-color-body)",
        borderTop: "1px solid var(--mantine-color-gray-2)",
        paddingTop: "var(--mantine-spacing-md)",
        paddingBottom: "var(--mantine-spacing-xs)",
        marginTop: "var(--mantine-spacing-xs)",
        zIndex: 2,
      }}
    >
      {children}
    </Group>
  );
}
